<template>
  <form ref="password_form">

    <md-card style="box-shadow:none">

      <md-card-header class="md-card-header-icon md-card-header-primary">
        <div class="card-icon">
          <md-icon>key</md-icon>
        </div>
        <h2 class="title" style="font-weight:bold!important">
          Edit Password
        </h2>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <md-field class="md-invalid">
              <label>New Password</label>
              <md-input v-model="user.password" type="password"/>
              <validation-error :errors="apiValidationErrors.password"/>
            </md-field>
            <md-field class="md-invalid">
              <label>Confirm New Password</label>
              <md-input v-model="user.password_confirmation" type="password"/>
              <validation-error :errors="apiValidationErrors.password_confirmation"/>
            </md-field>
          </div>
        </div>
      </md-card-content>

    </md-card>
    <md-card-actions>
      <md-button @click="changePassword" class="md-info">
        Save New Password
      </md-button>
    </md-card-actions>

  </form>
</template>

<script>
  import { ValidationError } from "@/components";
  import formMixin from "@/mixins/form-mixin";

  export default {
    name: "add-password-card",

    props: {
      user: Object,
    },
    methods: {
      async changePassword(){
        try {
          await this.$store.dispatch("users/updatePassword", 
              { id:this.user.id, 
                password:this.user.password, 
                password_confirmation: this.user.password_confirmation
              });
          this.$router.push('/users')
          await this.$store.dispatch(
            "alerts/success",
            "Password updated successfully."
          );
          
        } catch (e) {
          await this.$store.dispatch(
            "alerts/error",
            "Oops, something went wrong!"
          );
          this.setApiValidation(e.response.data.errors);
        }
      }
    },

     watch: {  
      'user.password'(value){  
        this.apiValidationErrors.password = [];
      },
      'user.password_confirmation'(value){  
        this.apiValidationErrors.password_confirmation = [];
      }
    },

    components: { ValidationError },
    mixins: [formMixin],


  };
</script>
